import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Tooltip } from 'sos-common/js/components/Tooltip/Tooltip';
import { RadioButtonGroup } from 'sos-common/js/components/FormControls/RadioButtonGroup';
import { RadioButton } from 'sos-common/js/components/FormControls/RadioButton';
import { CheckBoxGroup } from 'sos-common/js/components/FormControls/CheckBoxGroup';
import { CheckBox } from 'sos-common/js/components/FormControls/CheckBox';
import { StepChildProps } from 'sos-common/js/components/WizardStepper/WizardStepper.types';
import { makeTranslator, translateFunc } from '../../../utilities/translations';
import {
  ResearchOrderStore,
  ResearchOrderRegisters,
  researchOrderFiles,
} from '../../../models/ResearchOrderStore.types';
import { setFormValue } from 'sos-eservice-common/js/Redux/Actions';
import { ResearchOrderModel, ForskarBeställningFieldStates } from '../../../models';
import { getErrorMessageByFieldNameAfterHitSummary, getErrorMessageByFieldName } from '../../../utilities/helpers';
import DeliveryDefinitionInput from '../../../components/researchOrder/deliveryDefinition';
import SecurityAndPrivacyInput from '../../../components/researchOrder/securityAndPrivacy';
import { ValidationResult } from 'sos-common/js/commonTypes/validation.types';
export interface Step3Props extends StepChildProps {
  Translate?: translateFunc;
  registers?: ResearchOrderRegisters;
  setFormValue?: typeof setFormValue;
  researchOrder: ResearchOrderModel;
  researchOrderId: string;
  files: researchOrderFiles;
  validationResults: ValidationResult[];
  fullValidationResults: ValidationResult[];
  hasHitSummary?: boolean;
}
export interface Step3State {
  isValid: boolean;
  stepId: number;
}
class Step3 extends React.Component<Step3Props, Step3State> {
  constructor(props: any) {
    super(props);
    this.state = {
      isValid: this.props.stepState.isDone,
      stepId: this.props.stepState.stepId,
    };
  }
  getTitle = () => 'Dataskydd';
  componentDidMount() {
    this.props.reportToWizard({
      stepLabel: this.getTitle(),
    });
  }
  onChangeField = (field: ForskarBeställningFieldStates) => {
    this.props.setFormValue(field);
  };

  public render() {
    const { Translate, researchOrder, validationResults, fullValidationResults, hasHitSummary } = this.props;
    return (
      <div id="step3" tabIndex={-1}>
        <DeliveryDefinitionInput
          fieldName="CurrentResearchOrder.DeliveryDefinition"
          //validationResult={validationResults}
          errorMessage={getErrorMessageByFieldNameAfterHitSummary(
            validationResults,
            'CurrentResearchOrder.DeliveryDefinition.HowToDeliverData',
            hasHitSummary,
          )}
          onChange={this.onChangeField}
          hasHitSummary={hasHitSummary}
        />
        <br />
        <hr className="formdivider" />
        <div role="group" aria-labelledby="formatLeveransLabel">
          <h2 id="formatLeveransLabel" className="inlineblock">
            {Translate('/orderFormPage/formatLeverans')}
          </h2>
          <br />
          <CheckBoxGroup
            value={_.get(researchOrder, 'FileFormatDeliveredData', [] as string[])}
            fieldName="CurrentResearchOrder.FileFormatDeliveredData"
            errorMessage={getErrorMessageByFieldName(validationResults, 'CurrentResearchOrder.FileFormatDeliveredData')}
            onChange={this.onChangeField}>
            <CheckBox
              key={Translate('/orderFormPage/sas')}
              label={Translate('/orderFormPage/sas')}
              stringValue={Translate('/orderFormPage/sas')}
            />
            <CheckBox
              key={Translate('/orderFormPage/separeraFilTab')}
              label={Translate('/orderFormPage/separeraFilTab')}
              stringValue={Translate('/orderFormPage/separeraFilTab')}
            />
          </CheckBoxGroup>
        </div>
        <hr className="formdivider" />
        <SecurityAndPrivacyInput
          fieldName="CurrentResearchOrder.Security"
          validationResults={validationResults}
          fullValidationResults={fullValidationResults}
          onChange={this.onChangeField}
          hasHitSummary={hasHitSummary}
          errorMessage={getErrorMessageByFieldNameAfterHitSummary(
            validationResults,
            'CurrentResearchOrder.Security.ProtectedByPrivacyLaw',
            hasHitSummary,
          )}
        />
      </div>
    );
  }
}

const mapState2Props = (state: ResearchOrderStore) => {
  return {
    Translate: makeTranslator(state.globals.translations),
    registers: state.registers,
    researchOrder: state.formModel,
    researchOrderId: state.globals.orderId,
    files: state.files,
    purposeForSaveSerialNoOptions: state.globals.purposeForSaveSerialNoOptions,
    validationResults: state.validationState.validationResults,
    fullValidationResults: state.validationState.fullValidationResults,
    hasHitSummary: state.globals.hasHitSummary,
  } as Step3Props;
};

const mapDispatch2Props = (dispatch) => {
  return {
    setFormValue: bindActionCreators(setFormValue, dispatch),
  };
};

const StepThree = connect(mapState2Props, mapDispatch2Props)(Step3);
export { StepThree };
